<template>
  <!-- 测试提交 -->
  <div class="login-container">
    <div class="login-banner">
      <div class="logo-img">
        <img style="width: 100%" src="~@/assets/rimagLogo.png" alt="" />
      </div>
      <div class="login-title">
        <h5 style="font-family: 'FangSong'; font-size: 51px; line-height: 0px">
          一脉影像系统
        </h5>
      </div>
    </div>
    <div class="login-form">
      <el-tabs v-model="activeName">
        <el-tab-pane label="用户名密码登录" name="0">
          <el-form
            autoComplete="on"
            :model="loginForm"
            key="loginForm"
            :rules="loginRules"
            ref="loginForm"
            label-position="left"
          >
            <el-form-item prop="UserCode" class="login-form-username">
              <el-input
                name="UserCode"
                type="text"
                v-model="loginForm.UserCode"
                @blur="getvcode"
                autoComplete="on"
                placeholder="用户名"
              >
                <i slot="prefix">
                  <svg-icon icon-class="user"></svg-icon>
                </i>
              </el-input>
            </el-form-item>
            <el-form-item prop="Password" class="login-form-password">
              <el-input
                name="Password"
                :type="pwdType"
                @keyup.enter.native="handleLogin"
                v-model="loginForm.Password"
                autoComplete="on"
                placeholder="登录密码"
              >
                <i slot="prefix">
                  <svg-icon icon-class="lock"></svg-icon>
                </i>
              </el-input>
            </el-form-item>
            <el-form-item
              prop="InputCode"
              style="width: 350px"
              v-if="showVcodeImage"
            >
              <el-input
                class="form_code"
                v-model="loginForm.InputCode"
                placeholder="验证码"
              ></el-input>
              <div class="code" @click="refreshCode">
                <img :src="vcodeImageSrc" style="width: 100%; height: 40px" />
              </div>
              <div>
                <span style="color: #c0c4cc">看不清？</span
                ><span
                  @click="refreshCode"
                  style="cursor: pointer; color: #3a4a64"
                  >换一张</span
                >
              </div>
            </el-form-item>
            <el-form-item>
              <el-checkbox style="float: right" v-model="loginAuto"
                ><span style="cursor: pointer; color: #3a4a64"
                  >下次自动登录</span
                ></el-checkbox
              >
              <!-- <a style="float:left;color:#3a4a64" @click="resetPwd">重置密码</a> -->
              <a style="float: left; color: #3a4a64" @click="forgotPwd"
                >忘记密码</a
              >
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="width: 100%"
                :loading="loading"
                @click.native.prevent="handleLogin"
              >
                登 录
              </el-button>
            </el-form-item>
            <el-form-item>
              <div style="text-align: center; font-size: 12px">
                <span style="color: #c0c4cc"
                  >当前版本：{{ $getCfg("VUE_APP_BASE_VERSION") }}</span
                >
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="手机验证码登录" name="1">
          <el-form :model="form" key="form" ref="form" :rules="formRules">
            <el-form-item prop="Mobile" class="login-form-username">
              <el-input v-model="form.Mobile" placeholder="请输入11位手机号">
                <i slot="prefix">
                  <svg-icon icon-class="mobile"></svg-icon>
                </i>
              </el-input>
            </el-form-item>
            <el-form-item prop="SmsCode" style="margin-bottom: 20px">
              <el-input
                style="width: 172px"
                v-model="form.SmsCode"
                placeholder="请输入验证码"
              >
                <i slot="prefix">
                  <svg-icon icon-class="mobile"></svg-icon>
                </i>
              </el-input>
              <el-button class="sendvcode" @click="onSendVcode">{{
                sendVCodeText
              }}</el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="width: 100%"
                :loading="loading"
                @click.native.prevent="codeLogin"
              >
                登 录
              </el-button>
            </el-form-item>
            <el-form-item>
              <div style="text-align: center; font-size: 12px">
                <span style="color: #c0c4cc"
                  >当前版本：{{ $getCfg("VUE_APP_BASE_VERSION") }}</span
                >
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      title="忘记密码"
      :visible.sync="changeVisible"
      width="500px"
      :close-on-click-modal="false"
      custom-class="revisitDialog"
      ref="dialog"
    >
      <el-form
        size="mini"
        :model="ruleForm2"
        status-icon
        :rules="rules2"
        ref="ruleForm2"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="原密码" prop="OldPwd">
          <el-input
            type="password"
            v-model="ruleForm2.OldPwd"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="NewPwd">
          <el-input
            type="password"
            v-model="ruleForm2.NewPwd"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input
            type="password"
            v-model="ruleForm2.checkPass"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="pwddetermine('ruleForm2')"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="修改密码"
      :visible.sync="pwdVisible"
      width="500px"
      :close-on-click-modal="false"
      custom-class="revisitDialog"
      ref="dialog"
    >
      <el-form
        size="mini"
        :model="pwdForm"
        key="ruleForm2"
        status-icon
        :rules="pwdrules"
        ref="pwdForm"
        label-width="120px"
        v-if="pwdVisible"
        class="demo-ruleForm"
      >
        <el-form-item
          label="请输入您的账号"
          prop="code"
          class="login-form-username"
        >
          <el-input
            name="UserCode"
            type="text"
            v-model="pwdForm.code"
            autoComplete="on"
            placeholder="请输入您的账号"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" size="small" @click="userdetermine">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      title="忘记密码"
      :visible.sync="forgotVisible"
      width="400px"
      :close-on-click-modal="false"
      custom-class="revisitDialog"
      ref="dialog"
    >
      <el-form
        size="mini"
        :model="forgotForm"
        key="forgotForm"
        status-icon
        :rules="forgotrules"
        ref="forgotForm"
        v-if="forgotVisible"
        class="demo-ruleForm"
      >
        <el-form-item prop="Mobile" class="login-form-username">
          <el-input
            v-model="forgotForm.Mobile"
            placeholder="请输入11位手机号"
            autocomplete="off"
          >
            <i slot="prefix">
              <svg-icon icon-class="mobile"></svg-icon>
            </i>
          </el-input>
        </el-form-item>
        <el-form-item prop="SmsCode" style="margin-bottom: 20px">
          <el-input
            style="width: 172px"
            v-model="forgotForm.SmsCode"
            placeholder="请输入验证码"
          >
            <i slot="prefix">
              <svg-icon icon-class="mobile"></svg-icon>
            </i>
          </el-input>
          <el-button class="sendvcode" @click="onSendVcode">{{
            sendVCodeText
          }}</el-button>
        </el-form-item>
        <el-form-item prop="newPwd">
          <el-input
            type="password"
            v-model="forgotForm.newPwd"
            placeholder="请输入新密码"
            autocomplete="new-password"
          >
            <i slot="prefix">
              <svg-icon icon-class="lock"></svg-icon>
            </i>
          </el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
          <el-input
            type="password"
            v-model="forgotForm.checkPass"
            placeholder="请再次输入密码"
          >
            <i slot="prefix">
              <svg-icon icon-class="lock"></svg-icon>
            </i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="width: 100%; margin-top: 20px"
            :loading="loading"
            @click.native.prevent="resetLogin"
          >
            重置密码
          </el-button>
        </el-form-item>
        <div class="logininnow" @click="forgotVisible = false">立即登录</div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { isvalidUsername } from "@/utils/validate";
import { encode, decode } from "@/utils/base64";

export default {
  name: "login",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error("请输入正确的用户名"));
      } else if (value == "") {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    // const validatePass = (rule, value, callback) => {
    //   if (value.length < 6) {
    //     callback(new Error('密码不能小于6位'))
    //   } else {
    //     callback()
    //   }
    // }
    const validateVCode = (rule, value, callback) => {
      if (this.pwdErrorTime > 2 && value.trim() === "") {
        callback(new Error("请填写验证码。"));
      } else if (this.pwdErrorTime > 2 && value.length !== 4) {
        callback(new Error("请验证码位数必须为4位。"));
      } else {
        callback();
      }
    };
    var validatePastPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (value.length < 6) {
          callback(new Error("密码不能小于6位"));
        } else {
          callback();
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      // let regx = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[#@*&.$])[a-zA-Z\d#@*&.$]{8,}$/
      let regx = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{9,}$/;
      if (value === "") {
        callback(new Error("请输入密码。"));
      } else if (!regx.test(value)) {
        callback(
          new Error("密码需由包含大写字母、小写字母、数字且9位及以上组成")
        );
      } else {
        if (value.length < 6) {
          callback(new Error("密码不能小于6位"));
        } else {
          callback();
        }
        callback();
      }
    };

    var validatenewPass = (rule, value, callback) => {
      let regx = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{9,}$/;
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!regx.test(value)) {
        callback(new Error("需由包含大写字母、小写字母、数字且9位及以上组成"));
      } else {
        if (this.forgotForm.checkPass !== "") {
          this.$refs.forgotForm.validateField("checkPass");
        }
        if (value.length < 8) {
          callback(new Error("密码不能小于8位"));
        } else {
          callback();
        }
        callback();
      }
    };
    var validatenewPass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.forgotForm.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        if (value.length < 6) {
          callback(new Error("密码不能小于6位"));
        } else {
          callback();
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm2.NewPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        if (value.length < 6) {
          callback(new Error("密码不能小于6位"));
        } else {
          callback();
        }
        callback();
      }
    };
    return {
      changeVisible: false,
      readonlyInput: true,
      activeName: "0",
      ruleForm2: {
        LoginId: "",
        PastPwd: "",
        NewPwd: "",
      },
      form: {
        mobile: "",
        vcode: "",
      },
      rules2: {
        OldPwd: [{ required: true, trigger: "blur", message: "请输入原密码" }],
        NewPwd: [{ required: true, validator: validatePass, trigger: "blur" }],
        checkPass: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
      dialogFormVisible: false,
      version: process.env.VUE_APP_BASE_VERSION,
      loginForm: {
        UserCode: "",
        Password: "",
        InputCode: "",
        EncodeCode: "",
        IsMedicalConsortium: false,
      },
      forgotForm: {
        Mobile: "",
        SmsCode: "",
        newPwd: "",
        checkPass: "",
      },
      forgotrules: {
        Mobile: [{ required: true, trigger: "blur", message: "请输入手机号" }],
        SmsCode: [{ required: true, trigger: "blur", message: "请输入验证码" }],
        newPwd: [{ validator: validatenewPass, trigger: "blur" }],
        checkPass: [{ validator: validatenewPass2, trigger: "blur" }],
      },
      pwdForm: {
        code: "",
      },
      pwdrules: {
        code: [{ required: true, trigger: "blur", message: "请输入您的账号" }],
      },
      formRules: {
        Mobile: [{ required: true, trigger: "blur", message: "请输入手机号" }],
        SmsCode: [{ required: true, trigger: "blur", message: "请输入验证码" }],
      },
      loginRules: {
        UserCode: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        Password: [
          { required: true, trigger: "blur", validator: validatePastPwd },
        ],
        InputCode: [
          { required: false, trigger: "blur", validator: validateVCode },
        ],
      },
      // rules2: {
      //   Code: [
      //     { required: true, trigger: "blur", validator: validateUsername },
      //   ],
      //   PastPwd: [
      //     { required: true, trigger: "blur", validator: validatePastPwd },
      //   ],
      //   NewPwd: [{ required: false, trigger: "blur", validator: validatePass }],
      // },
      loading: false,
      pwdType: "Password",
      vcodeImageSrc: "",
      showVcodeImage: false,
      loginAuto: false,
      loginAutoControl: false,
      sendVCodeText: "发送验证码",
      sendVCodeSecond: 60,
      pwdVisible: false,
      forgotVisible: false,
    };
  },
  mounted: function () {
    // 获取图片验证码
    this.getvcode();
    // 本地存储中获取自动登录状态
    var loginAutoFromLocalStorage = localStorage.getItem("loginAuto");
    if (loginAutoFromLocalStorage) {
      var userinfo = localStorage.getItem("userinfo");
      this.loginForm.UserCode = userinfo.split("&")[0];
      this.loginForm.Password = decode(userinfo.split("&")[1]);
      this.handleLogin();
    }
  },
  methods: {
    cancelReadOnly() {
      this.readonlyInput = false;
    },
    //忘记密码
    forgotPwd() {
      this.pwdVisible = true;
    },
    userdetermine() {
      this.$refs["pwdForm"].validate((valid) => {
        if (valid) {
          this.$store
            .dispatch("CheckUser", this.pwdForm.code)
            .then((response) => {
              if (response.code == 50010) {
                this.pwdVisible = false;
                this.$alert(
                  "当前账号未绑定手机号，您可联系管理员进行重置密码！",
                  "",
                  {
                    confirmButtonText: "好的",
                  }
                );
              } else {
                this.pwdVisible = false;
                this.forgotVisible = true;
                this.forgotForm = {
                  Mobile: "",
                  SmsCode: "",
                  newPwd: "",
                  checkPass: "",
                };
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    pwddetermine() {
      this.$refs["ruleForm2"].validate((valid) => {
        if (valid) {
          this.ruleForm2.LoginId = this.loginForm.UserCode;
          // { LoginId: this.loginForm.UserCode }
          this.$store
            .dispatch("ModifyPwd", this.ruleForm2)
            .then(() => {
              this.changeVisible = false;
              this.$message.success("修改成功");
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    onSendVcode: function () {
      var vm = this;
      let mobile = "";
      if (this.forgotVisible) {
        mobile = this.forgotForm.Mobile.trim();
      } else {
        mobile = this.form.Mobile.trim();
      }
      if (mobile === "") {
        this.$message.error("请输入手机号。");
        return false;
      }
      if (mobile.length !== 11) {
        this.$message.error("手机号必须为11位。");
        return false;
      }
      if (
        this.sendVCodeText === "发送验证码" ||
        this.sendVCodeText === "重新发送"
      ) {
        this.$store
          .dispatch("LoginSms", mobile)
          .then((response) => {
            console.log(response);
            // 倒计时
            vm.setSendVCodeText(this.sendVCodeSecond);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    determine() {
      this.getvcode();
      this.loginForm.Mobile = this.form.mobile;
      this.loginForm.SmsCode = this.form.vcode;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          if (this.showVcodeImage && this.loginForm.InputCode.trim() === "") {
            this.$message.error("请填写验证码。");
            return false;
          } else if (
            this.showVcodeImage &&
            this.loginForm.InputCode.length !== 4
          ) {
            this.$message.error("请验证码位数必须为4位。");
            return false;
          }
          this.loading = true;
          // 自动登录写入localStorage
          if (this.loginAuto) {
            var loginAutoFromLocalStorage = localStorage.getItem("loginAuto");
            if (!loginAutoFromLocalStorage) {
              var encodePassword = encode(this.loginForm.Password);
              localStorage.setItem("loginAuto", "true");
              localStorage.setItem(
                "userinfo",
                this.loginForm.UserCode + "&" + encodePassword
              );
            }
          } else {
            localStorage.removeItem("loginAuto");
            localStorage.removeItem("userinfo");
          }
          this.$store
            .dispatch("Login", this.loginForm)
            .then((response) => {
              if (response.code == 50001) {
                this.dialogFormVisible = false;
                this.pwdVisible = true;
              } else {
                this.getvcode();
                this.$router.push({ path: "/" });
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    setSendVCodeText: function (second) {
      var vm = this;
      if (second > 0) {
        second--;
        vm.sendVCodeText = "重新发送" + second + "秒";
        vm.$forceUpdate();
        setTimeout(function () {
          vm.setSendVCodeText(second);
        }, 1000);
      } else {
        this.sendVCodeText = "重新发送";
      }
    },
    showPwd() {
      if (this.pwdType === "Password") {
        this.pwdType = "";
      } else {
        this.pwdType = "Password";
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (
            this.loginForm.Code !== "" &&
            this.loginForm.Code !== this.identifyCode
          ) {
            this.refreshCode();
            this.$alert("请重新登录", "验证码不正确,请重新输入！", {
              confirmButtonText: "好的",
            });
            this.loading = false;
            return false;
          }
          this.$store
            .dispatch("Login", this.loginForm)
            .then((response) => {
              if (response.code == 50001) {
                this.loading = false;
                // this.pwdVisible = true;
                this.changeVisible = true;
              } else {
                this.pwdErrorTime = this.$store.state.user.pwdErrorTime;
                if (this.pwdErrorTime === 0) {
                  this.loading = false;
                  sessionStorage.setItem("pwd", JSON.stringify(this.loginForm));
                  this.$router.push({ path: "/" });
                } else {
                  this.loading = false;
                }
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });

      // let regx = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[#@*&.$])[a-zA-Z\d#@*&.$]{8,}$/
      // // this.dialogFormVisible = true
      // if (regx.test(this.loginForm.Password)) {
      //   this.dialogFormVisible = true
      // }else{
      //   this.pwdVisible = true
      //   if(this.$refs.ruleForm2!== undefined)this.$refs.ruleForm2.resetFields();
      //   // this.$message.error('由于您的密码强度太低，需强制重置密码。')
      // }
    },
    resetLogin() {
      this.$refs.forgotForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("ResetPwdBySms", {
              Code: this.pwdForm.code,
              Mobile: this.forgotForm.Mobile,
              SmsCode: this.forgotForm.SmsCode,
              NewPassWord: this.forgotForm.newPwd,
            })
            .then((response) => {
              this.loading = false;
              this.$message.success("重置成功，请输入新密码登录。");
              this.forgotVisible = false;
              // if (response.code == 50001) {
              //   this.loading = false;
              //   this.pwdVisible = true;
              // }else{
              //   this.loading = false
              //   this.$router.push({ path: '/' })
              // }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    codeLogin() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("Codelogin", this.form)
            .then((response) => {
              if (response.code == 50001) {
                this.loading = false;
                this.changeVisible = true;
              } else {
                this.loading = false;
                this.$router.push({ path: "/" });
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 获取图片验证码
    getvcode() {
      if (this.loginForm.UserCode.trim() !== "") {
        this.$store
          .dispatch("GetVCodeImage", this.loginForm.UserCode)
          .then((response) => {
            this.showVcodeImage = response.data.needCaptcha;
            this.vcodeImageSrc =
              "data:image/jpeg;base64," + response.data.image;
            this.loginForm.EncodeCode = response.data.encodeCode;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    refreshCode() {
      this.getvcode();
    },
    resetPwd() {
      this.$router.push({ path: "/resetpwd" });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #f8f8f8;
$dark_gray: #889aa4;
$light_gray: #eee;
@media screen and (max-height: 768px) {
  .login-footer {
    position: relative !important;
  }
}
::v-deep.login-form {
  .el-tabs__nav-scroll {
    padding: 0 20px;
  }
}
.demo-ruleForm {
  width: 90%;
  margin: 0 auto;
}
.logininnow {
  cursor: pointer;
  font-size: 12px;
  text-align: center;
  margin-top: 10px;
  color: #397ee3;
}
.sendvcode {
  width: 118px;
  margin-left: 10px;
  border: 1px solid #397ee3;
  color: #397ee3;
}
.login-container {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  .login-banner {
    background: url("~@/assets/login_bg.jpg") no-repeat top center;
    background-size: 100% 330px;
    padding-top: 330px;
    position: relative;
    .logo-img {
      position: absolute;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      top: 115px;
      width: 225px;
    }
  }
  .login-title {
    width: 100%;
    height: 50px;
    font-size: 38px;
    color: #fff !important;
    text-align: center;
    position: absolute;
    left: 0;
    top: 180px;
  }
  .login-form {
    left: 0;
    right: 0;
    width: 300px;
    padding: auto;
    margin: auto;
    margin-top: 40px;
    margin-bottom: 50px;

    .el-form-item {
      margin-bottom: 0;
    }
    .el-form-item.login-form-username {
      margin-bottom: 22px;
    }
    .el-form-item.login-form-password {
      margin-bottom: 8px;
    }
  }
  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .login-footer {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    font-size: 14px;
    margin: 10px;
    .text-right {
      text-align: right;
    }
  }
  .code {
    width: 114px;
    height: 40px;
    display: inline-block;
    float: left;
    margin-left: 10px;
  }
  .form_code {
    width: 100px;
    float: left;
  }
}
</style>
